{
  "id": "main",
  "ga": "G-ZTEQBFCRXZ",
  "name": "Gramene",
  "version": "v69",
  "description": "Comparative plant genomics for crops and model organisms",
  "url": "https://gramene.org",
  "ensemblURL": "https://ensembl.gramene.org",
  "ensemblSite": "https://ensembl.gramene.org",
  "ensemblRest": "https://data.gramene.org/ensembl69",
  "grameneData": "https://data.gramene.org/v69",
  "targetTaxonId": 3702,
  "portals68": ['browser','reactome','pansites','curated','blast','climtools','atlas','mart','tools','archive'],
  "portals": ['browser','reactome','pansites','tools','climtools','curated','blast','atlas','videotutorials','EG_mart'],
  "portals2": ['pansites','browser','reactome','climtools','blast','mart','tools','atlas','trackhub','outreach','downloads','archive'],
  "showInMenu": true,
  "showNews": true,
  "showGuides": false,
  "showFeed": true,
  "showTweets": true,
  "showViews": false,
  "hideAlerts": false,
  "date": "2025-08-01",
  "slides": [],
  "playlistIds": [
    'PLqQHG-yuRY1-z7-KKYe-BDL-lriaocrbZ', // SB EBI training
  ],
  details: {
    sequences: true,
    VEP: false,
    location: true,
    expression: true,
    homology: true,
    pathways: true,
    pubs: true,
    xrefs: true
  },
  "panSite" : {
    oryza_sativa : {
      url: "https://oryza.gramene.org",
      name: "Gramene Oryza",
      svg: "./static/images/oryza_logo.svg",
      api: "https://data.gramene.org/oryza_v8"
    },
    zea_mays : {
      url: "https://maize-pangenome.gramene.org",
      name: "Gramene Maize",
      svg: "./static/images/maize_logo.svg",
      api: "https://data.gramene.org/maize_v5"
    },
    vitis_vinifera : {
      url: "https://vitis.gramene.org",
      name: "Gramene Grapevine",
      svg: "./static/images/grapevine_logo.svg",
      api: "https://data.gramene.org/grapevine_v4"
    },
    "sorghum_bicolor" : {
      "url": "https://sorghumbase.org/genes",
      "name": "SorghumBase",
      "svg": "./static/images/sorghum_logo.svg",
      "api": "https://data.sorghumbase.org/sorghum_v9"
    }
  }
}
